import { useEffect } from 'react';

import { impostaNicknameQgammon } from '@/lib/qgammon/displayName';
import { useAppSelector } from '@/store/hooks';

/**
 * Il nome pubblico del backgammon (I-898): il nickname QLASH, dallo store alla memoria di `lib/qgammon/displayName.ts`, da dove
 * `qgammonAuthHeaders` (che non e' un componente) lo prende per `X-QGammon-Display-Name`.
 *
 * ⛔ Si legge `nicknameQlash`, MAI `user.username`: quello ripiega sul `name` di Limulo quando `requiresNickname` manca
 * (`lib/limulo/identity.ts`), cioe' puo' essere un valore in forma che non e' il nickname.
 * La dipendenza sul valore fa seguire alla memoria ogni cambio dello store: la scelta del nickname (`setNickname`), il cambio di
 * account e il logout (`user: null` ⇒ `undefined`: nessun nickname resta alla persona dopo).
 *
 * @param attivo `true` solo quando e' Limulo a possedere l'identita' (`env.featureLimuloEnabled`): senza, nessuno scrive il nickname.
 */
export function useNicknameQgammon(attivo: boolean): void {
  const nicknameQlash = useAppSelector((s) => s.auth.user?.nicknameQlash);
  useEffect(() => {
    if (attivo) impostaNicknameQgammon(nicknameQlash);
  }, [attivo, nicknameQlash]);
}
